// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getDatabase } from 'firebase/database';
import {
  getStorage,
  ref as stRef,
  uploadBytes,
  getDownloadURL,
} from 'firebase/storage';
// Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyDJupdYO4V-OU5VxWlKxzxJi5IsqfJ-rUs',
  authDomain: 'por-1-mundo-mejor.firebaseapp.com',
  databaseURL: 'https://por-1-mundo-mejor-default-rtdb.firebaseio.com',
  projectId: 'por-1-mundo-mejor',
  storageBucket: 'por-1-mundo-mejor.firebasestorage.app',
  messagingSenderId: '694443846309',
  appId: '1:694443846309:web:bc5b51e601219f98e17b4c',
  measurementId: 'G-PRFQQC9XHN',
};

// Initialize Firebase
// const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
//const storage = getStorage(app);
//const database = getDatabase(app);
let app, analytics; //, auth, database;
// Initialize Firebase
export function initFb() {
  app = initializeApp(firebaseConfig);
  analytics = getAnalytics(app);
  //auth = getAuth(app);
}

//init();

export const getApp = app;
export const initAnalytics = analytics;
export { stRef, uploadBytes, getDownloadURL };
//export const db = database;
// export const initAuth = auth;
// export const db = database;
// export const storage = getStorage(app);
